/**
 * ResponseStatusError
 * used when response status is error but we didn't recognise the error code
 */
export default class UnrecognisedResponseCodeError extends Error {
  
  // TODO: this is duck-typing, because babel is broken
  static type = "UnrecognisedResponseCodeError";
  
  constructor(response) {
    const { code, message } = response.data;
    super(`Unknown response code: ${code}: ${message}`);
    this.response = response;
    this.type = UnrecognisedResponseCodeError.type;
  }
  
}



// WEBPACK FOOTER //
// ./src/lib/appserver/responseExceptions/UnrecognisedResponseCodeError.js